// Background Block View Component
// Read-only view of background image for public portal pages
import React from 'react';

const BackgroundBlockView = ({ content }) => {
  if (!content?.url) {
    return null;
  }

  const getBackgroundStyle = () => {
    const baseStyle = {
      backgroundImage: `url(${content.url})`,
      backgroundRepeat: 'no-repeat'
    };

    switch (content.position) {
      case 'stretch':
        return {
          ...baseStyle,
          backgroundSize: '100% 100%'
        };
      case 'repeat':
        return {
          ...baseStyle,
          backgroundRepeat: 'repeat',
          backgroundSize: 'auto'
        };
      default: // fit
        return {
          ...baseStyle,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
    }
  };

  return (
    <div
      className="h-full"
      style={getBackgroundStyle()}
    />
  );
};

export default BackgroundBlockView;
